"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import {PaveScaleCard} from "@/components/common/pave-scale-card";
import { useNavigate } from "react-router-dom";

export default function Home() {
    const navigate = useNavigate();

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Centre de Ressources"}
                                middleBreadcrumbs={[{title: "L’Office et Vous", link: "/espace-pro/office-et-vous"}]}
                                description={"Découvrez les missions et la vision de cette structure dotée de ressources importantes au cœur de l’écosystème touristique ivoirien."} />

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">
                <div className={"grid grid-cols-1 md:grid-cols-3 gap-4"}>
                    <PaveScaleCard title={<>Vos Outils d'Accueil</>} buttonLabel={"Consulter"} className={"h-[400px]"}
                                   link="/espace-pro/office-et-vous/centre-de-ressources/vos-outils-accueil"
                                   image={"/images/espace-pro/office-et-vous/centre-de-ressources/1.jpg"}
                                   titleClassName={"font-playfair-display-italic text-xl"}/>

                    <PaveScaleCard title={<>Ressources du Tourisme Responsable</>} buttonLabel={"Consulter"} className={"h-[400px]"}
                                   link="/espace-pro/office-et-vous/centre-de-ressources/ressources-tourisme-responsable"
                                   image={"/images/espace-pro/office-et-vous/centre-de-ressources/2.jpg"}
                                   titleClassName={"font-playfair-display-italic text-xl"}/>

                    <PaveScaleCard title={<>La Disponibilté des Hébergements, Restautaurants et Maquis</>} buttonLabel={"Consulter"} className={"h-[400px]"}
                                   link="/espace-pro/office-et-vous/centre-de-ressources/disponibilite"
                                   image={"/images/espace-pro/office-et-vous/centre-de-ressources/3.jpg"}
                                   titleClassName={"font-playfair-display-italic text-xl"}/>
                </div>
            </SectionPage>

        </div>
    );
}
